import React, { useState } from 'react';
import T from 'prop-types';
import { Popover as AntdPopover } from 'antd';
import { PopoverWithContext } from '../popover-with-context';

export const Popover = ({
  trigger,
  placement,
  content,
  ...rest
}) => {
  const [visible, setVisible] = useState(false);

  const handleClickContent = (e) => {
    e.stopPropagation();
    return !e.target.dataset.closePopover && setVisible(false);
  };

  return (
    <PopoverWithContext
      component={AntdPopover}
      trigger={trigger}
      placement={placement}
      visible={visible}
      onVisibleChange={() => setVisible(!visible)}
      content={<div onClick={e => handleClickContent(e)}> {content} </div>}
      {...rest}
    />
  );
};

Popover.propTypes = {
  trigger: T.string,
  placement: T.string,
  content: T.element.isRequired,
};

Popover.defaultProps = {
  trigger: 'click',
  placement: 'bottomRight',
};



// WEBPACK FOOTER //
// ./src/components/popovers/popover/index.js